import { AxiosResponse } from 'axios';

import { maintenanceService } from './service';

class MaintenanceViewController {
  public checkForMaintenance = (response: AxiosResponse) => {
    if (typeof response.data === 'string' && response.data.includes('Under Maintenance')) {
      maintenanceService.setUnderMaintenance(true);
    }
  };

  public activateMaintenanceMode = () => {
    maintenanceService.setUnderMaintenance(true);
  };
}

export const maintenanceViewController = new MaintenanceViewController();
